module.exports = __webpack_public_path__ + "img/selected6-min.f5a8984a.png";